import { Outlet, RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.vendors.root,
    element: loadable(() => import('./pages/VendorsPage')),
  },
  {
    path: paths.vendors.details.root,
    element: loadable(() => import('./pages/VendorsDetailsPage')),
    children: [
      {
        path: 'tickets',
        element: <Outlet />,
        children: [
          { path: 'new', element: <Outlet /> },
          {
            path: ':ticketId',
            element: <Outlet />,
            children: [
              { path: 'edit', element: <Outlet /> },
              { path: 'comments', element: <Outlet /> },
              { path: 'comments/new', element: <Outlet /> },
              { path: 'related-tasks', element: <Outlet /> },
              { path: 'related-tasks/new', element: <Outlet /> },
              { path: 'activity-log', element: <Outlet /> },
            ],
          },
        ],
      },
      {
        path: paths.vendors.details.tab,
        element: <Outlet />,
      },
    ],
  },
];
